import Button from 'components/Button';
import { Footer } from './styled';

interface FormFooterProps {
    formId?: string;
    submitButtonLabel?: string;
    submitDisabled?: boolean;
    onCancelClick?: () => void;
}

const FormFooter = ({
    formId,
    submitButtonLabel = 'Create',
    submitDisabled = false,
    onCancelClick = () => {},
}: FormFooterProps) => (
    <Footer>
        <Button
            label="Close"
            variant="outline-brand"
            borderRadius="semi-rounded"
            className="rainbow-m-right_medium"
            onClick={onCancelClick}
        />
        <Button
            label={submitButtonLabel}
            variant="brand"
            form={formId}
            type="submit"
            borderRadius="semi-rounded"
            disabled={submitDisabled}
        />
    </Footer>
);

export default FormFooter;
